import { render } from "./SelectAcademyComponent.vue?vue&type=template&id=3afa0330"
import script from "./SelectAcademyComponent.vue?vue&type=script&lang=js"
export * from "./SelectAcademyComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__